import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance, clearInteractionState } from '../msalInstance';
import { apiTokenRequest } from '../authConfig';

/** Scopes for interactive login when silent token acquisition needs user consent. */
export function getInteractiveLoginScopes(): string[] {
  const base = ['User.Read', 'openid', 'profile'] as const;
  if (!apiTokenRequest?.scopes?.length) return [...base];
  return [...apiTokenRequest.scopes, ...base];
}

/** True when Azure AD requires interactive consent (e.g. AADSTS65001 / invalid_grant). */
export function requiresInteractiveConsent(error: unknown): boolean {
  if (error instanceof InteractionRequiredAuthError) return true;
  if (!error || typeof error !== 'object') return false;

  const e = error as {
    errorCode?: string;
    errorMessage?: string;
    message?: string;
    suberror?: string;
  };
  const code = (e.errorCode ?? '').toLowerCase();
  const sub = (e.suberror ?? '').toLowerCase();
  const text = `${e.errorMessage ?? ''} ${e.message ?? ''}`.toLowerCase();

  return (
    code === 'invalid_grant' ||
    sub === 'consent_required' ||
    text.includes('consent_required') ||
    text.includes('aadsts65001')
  );
}

/** Redirect to Azure AD so the user can grant API scope consent. */
export async function triggerConsentRedirect(): Promise<void> {
  const scopes = getInteractiveLoginScopes();
  const loginHint = msalInstance.getAllAccounts()[0]?.username;
  console.warn('[Auth] Consent required for backend API — redirecting for interactive login…');
  clearInteractionState();
  try {
    await msalInstance.loginRedirect({ scopes, ...(loginHint ? { loginHint } : {}) });
  } catch {
    /* redirect already in progress */
  }
}
